import {
	SET_APP_INDIVIDUAL,
	SET_APP_JOINT,
	SET_RETURNED_FROM_THIRD_PARTY_SITE,
	SET_PROVIDER_ID,
	SET_RECEIVED_PROVIDER_TO_USE_FROM_STORIS,
	SET_STORE_NAME,
	SET_DEFAULT_PROVIDER,
	SET_USER_CONSENTED,
	SET_ADDITIONAL_PROVIDER_REVIEW_CHECKBOX_DISPLAYED,
	SET_CFA_TRACE_ID
} from './constants';

export const setAppIndividual = () => ({
	type: SET_APP_INDIVIDUAL,
});

export const setAppJoint = () => ({
	type: SET_APP_JOINT,
});

export const setReturnedFromThirdPartySite = () => ({
	type: SET_RETURNED_FROM_THIRD_PARTY_SITE,
});

export const setProviderId = providerId => ({
	type: SET_PROVIDER_ID,
	providerId,
});

export const setReceivedProviderToUseFromSTORIS = receivedProviderToUseFromSTORIS => ({
	type: SET_RECEIVED_PROVIDER_TO_USE_FROM_STORIS,
	receivedProviderToUseFromSTORIS,
});

export const setStoreName = storeName => ({
	type: SET_STORE_NAME,
	storeName,
});

export const setDefaultProvider = defaultProvider => ({
	type: SET_DEFAULT_PROVIDER,
	defaultProvider,
});

export const setUserConsented = userConsented => ({
	type: SET_USER_CONSENTED,
	userConsented,
});

export const setAdditionalProviderReviewCheckboxDisplayed = additionalProviderReviewCheckboxDisplayed => ({
	type: SET_ADDITIONAL_PROVIDER_REVIEW_CHECKBOX_DISPLAYED,
	additionalProviderReviewCheckboxDisplayed,
});

export const setCFATraceId = cfaTraceId => ({
	type: SET_CFA_TRACE_ID,
	cfaTraceId,
});
